import AgreementType from 'components/blocks/Delta/Inputs/AgreementType';
import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import Province from 'components/blocks/Delta/Inputs/Province';
import TestCommunity from 'components/blocks/Delta/Inputs/TestCommunity';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormDatosPersonales from 'components/blocks/ManagementNewForms/ButtonGroups/FormDatosPersonales';
import FormInputFecha from 'components/blocks/ManagementNewForms/Inputs/FormInputFecha';
import FormInputIPF from 'components/blocks/ManagementNewForms/Inputs/FormInputIPF'; import FormBotonSubmit from 'components/blocks/ManagementNewForms/Inputs/FormInputSubmit';
import FormInputText from 'components/blocks/ManagementNewForms/Inputs/FormInputTexto';
import FormObservaciones from 'components/blocks/ManagementNewForms/Inputs/FormObservaciones';
import { opacity } from 'html2canvas/dist/types/css/property-descriptors/opacity';
import React, { useEffect, useState } from 'react'
import { FormProvider, set, useFieldArray, useForm, useWatch } from 'react-hook-form';
import get from 'lodash/get';
import FormInputTable, { fillArray } from 'components/blocks/ManagementNewForms/Inputs/FormInputTable';
import Loader from 'components/blocks/Loader/Loader';
import useCreatetCertificadoEmpresaIt from 'services/record/CertificadoEmpresa/useCreateCertificadoEmpresaIt';
import useUpdateCertificadoEmpresaItByID from 'services/record/CertificadoEmpresa/useUpdateCertificadoEmpresaItByID';
import FormInputRadioGroup from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputRadioGroup';
import FormInputRadioTable from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputRadioTable';
import AccordionDisplay from 'components/blocks/ManagementNewForms/Accordion/AccordionDisplay';
import TextAreaDefault from 'components/blocks/ManagementNewForms/TextArea/TextAreaDefault';
import FormInputCheckboxTable from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputCheckBoxTable';
import useCreateDeclaracionJuradaCeseActividadDirecta from 'services/record/DeclaracionJuradaCeseActividadDirecta/useCreateDeclaracionJuradaCeseActividadDirecta';
import useUpdateDeclaracionJuradaCeseActividadDirectaByID from 'services/record/DeclaracionJuradaCeseActividadDirecta/useUpdateDeclaracionJuradaCeseActividadDirecta';
import InputTextIntegration from 'components/blocks/ManagementNewForms/Inputs/InputTextIntegration';
import FormInfoCreateUpdate from 'components/blocks/ManagementNewForms/Inputs/FormInfoCreateUpdate';


const DeclaracionJuradaCeseActividadDirecta = ({ info, dataUser, onSuccess }: { info: boolean; dataUser: any, onSuccess?: () => void }) => {


  const formMethods = useForm();
  const { register, handleSubmit, setError, formState: { errors }, setValue, watch, reset, control, getValues } = formMethods;

  const { createDeclaracionJuradaCeseActividadDirecta, dataCreateDeclaracionJuradaCeseActividadDirecta, errorCreateDeclaracionJuradaCeseActividadDirecta, loadingCreateDeclaracionJuradaCeseActividadDirecta, successCreateDeclaracionJuradaCeseActividadDirecta } = useCreateDeclaracionJuradaCeseActividadDirecta();
  const { dataUpdateDeclaracionJuradaCeseActividadDirectaById, errorUpdateDeclaracionJuradaCeseActividadDirectaById, loadingUpdateDeclaracionJuradaCeseActividadDirectaById, successUpdateDeclaracionJuradaCeseActividadDirectaById, updateDeclaracionJuradaCeseActividadDirectaById } = useUpdateDeclaracionJuradaCeseActividadDirectaByID();

  const [datosAPI, setDatosAPI] = useState(dataUser);
  const [bloquearEnvio, setBloquearEnvio] = useState<boolean>(false);
  const [loader, setLoader] = useState(false);





  const emptyDatosEconomicos = {
    EjercicioEconomico: null,
    Ingresos: null,
    Gastos: null,
    Perdidas: null,
    PorcentajePerdidasIngresos: null,
  };
  useEffect(() => {
    const a = parseFloat(getValues('CeseActividad.EjecucionJudicialIngreso'));
    const b = parseFloat(getValues('CeseActividad.EjecucionJudicialImporteEjecuciones'));

    // Evitar división por 0 o valores no numéricos
    if (!isFinite(a) || a === 0 || !isFinite(b)) {
      setValue('CeseActividad.EjecucionJudicialPorcentaje', null);
      return;
    }

    const calculo = (b * 100) / a;
    const redondeado = Number(calculo.toFixed(2)); // Máx. 2 decimales

    if (!isNaN(redondeado)) {
      setValue('CeseActividad.EjecucionJudicialPorcentaje', redondeado);
    } else {
      setValue('CeseActividad.EjecucionJudicialPorcentaje', null);
    }

  }, [
    watch('CeseActividad.EjecucionJudicialIngreso'),
    watch('CeseActividad.EjecucionJudicialImporteEjecuciones')
  ]);

  const tipoMotivoCese = useWatch({
    control,
    name: "CeseActividad.TipoMotivoCese"
  });

  const declaracionCese = useWatch({
    control,
    name: "CeseActividad.DeclaracionCese"
  });

  const validateDatosEconomicos = (rows: any[]) => {
    if (!(declaracionCese === true && tipoMotivoCese === '0')) {
      return true;
    }

    if (!Array.isArray(rows) || rows.length === 0) {
      return "Debe rellenar los datos económicos";
    }

    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];

      const { EjercicioEconomico, Ingresos, Gastos } = row || {};

      if (
        EjercicioEconomico === null || EjercicioEconomico === "" ||
        Ingresos === null || Ingresos === "" ||
        Gastos === null || Gastos === ""
      ) {
        return "Debe completar todos los campos de datos económicos";
      }
    }

    return true;
  };

  const adaptApiResponseToDefaultValues = (data: any) => {
    if (data) {

      reset({
        DatosPersonales: {
          SolicitanteNombre: data?.DatosPersonales?.Nombre || "",
          SolicitanteApellido1: data?.DatosPersonales?.Apellido1 || "",
          SolicitanteApellido2: data?.DatosPersonales?.Apellido2 || "",
          SolicitanteIPF: data?.DatosPersonales?.IPF || "",
          SolicitanteIPFTipo: data?.DatosPersonales?.IPFTipo?.toString() || "1",
          SolicitanteNombreCompleto: data?.DatosPersonales?.Nombre + " " + data?.DatosPersonales?.Apellido1 + " " + data?.DatosPersonales?.Apellido2 || "",
          SolicitanteTelefono: data?.DatosPersonales?.Telefono || "",
          SolicitanteFijo: data?.DatosPersonales?.Fijo || "",
          SolicitanteDomicilio: data?.DatosPersonales?.Domicilio || "",
          SolicitanteCodigoPostal: data?.DatosPersonales?.CodigoPostal || "",
          SolicitanteProvincia: data?.DatosPersonales?.CodigoProvincia || "",
          SolicitanteProvinciaDescripcion: data?.DatosPersonales?.Provincia || "",
          SolicitanteComunidadCodigo: data?.DatosPersonales?.ComunidadCodigo || "",
          SolicitanteNumeroSS: data?.DatosPersonales?.NumeroSeguridadSocial || "",
        },

        CeseActividad: {
          DeclaracionCese: data?.MotivoCeseActividad ?? false,
          TipoMotivoCese: data?.TipoMotivoCeseActividad?.toString() || null,
          FechaMotivoCese: data?.FechaMotivoCese || null,
          DatosEconomicos: fillArray(data?.DatosEconomicosCeseActividad, 2, emptyDatosEconomicos),

          TecnicosProductivosOrganizativos: data?.TecnicosProductivosOrganizativos || "",
          EstablecimientoMercantil: data?.TitularEstablecimiento ?? false,
          DomicilioEstablecimiento: data?.DomicilioEstablecimiento || "",

          EjecucionJudicialIngreso: data?.EjecucionesCobroDeudas?.ImporteTotalIngresos || null,
          EjecucionJudicialImporteEjecuciones: data?.EjecucionesCobroDeudas?.ImporteTotalEjecuciones?.toString() || "",
          EjecucionJudicialPorcentaje: data?.EjecucionesCobroDeudas?.PorcentajeEjecucionesSobreIngresos?.toString() || ""
        },

      });
    }

  }

  useEffect(() => {
    adaptApiResponseToDefaultValues(dataUser);
  }, [dataUser]);

  useEffect(() => {
    setDatosAPI(dataUser);
  }, [dataUser]);



  const datosEconomicos = useWatch({
    control,
    name: "CeseActividad.DatosEconomicos"
  }) || [];

  useEffect(() => {
    if (!Array.isArray(datosEconomicos)) return;

    datosEconomicos.forEach((row, index) => {

      const ingresos = Number(row?.Ingresos) || 0;
      const gastos = Number(row?.Gastos) || 0;

      const perdidasCalc = ingresos - gastos;
      const perdidasRounded = Number(perdidasCalc.toFixed(2));

      const rowPerdidasNum = Number(row?.Perdidas ?? 0);

      // 1. SOLO setValue cuando realmente hay cambio numérico
      if (rowPerdidasNum !== perdidasRounded) {
        setValue(
          `CeseActividad.DatosEconomicos.${index}.Perdidas`,
          perdidasRounded,
          { shouldDirty: true, shouldTouch: true }
        );
      }

      // 2. Porcentaje
      let porcentajeCalc = 0;
      if (ingresos !== 0) {
        porcentajeCalc = Number(((perdidasCalc * 100) / ingresos).toFixed(2));
      }

      const rowPorcentajeNum = Number(row?.PorcentajePerdidasIngresos ?? 0);

      if (rowPorcentajeNum !== porcentajeCalc) {
        setValue(
          `CeseActividad.DatosEconomicos.${index}.PorcentajePerdidasIngresos`,
          porcentajeCalc,
          { shouldDirty: true, shouldTouch: true }
        );
      }
    });

  }, [datosEconomicos]);



  const onSubmit = async (data: any) => {
    setLoader(true);

    let prestacionId = dataUser?.PrestacionId || null;

    const datosEnvio = {


      // IDENTIFICACIÓN
      Id: dataUser?.Id || null,
      ExternalId: dataUser?.ExternalId || 0,
      PersonaId: dataUser?.PersonaId || 0,
      UsuarioId: dataUser?.UsuarioId || null,
      ExpedienteId: dataUser?.ExpedienteId || null,
      PrestacionId: prestacionId,

      Acepto: data?.Acepto ?? false,

      // -----------------------------------
      // DATOS PERSONALES
      // -----------------------------------
      datosPersonales: {
        nombre: dataUser?.DatosPersonales?.Nombre ?? dataUser?.datosPersonales?.nombre ?? "",
        apellido1: dataUser?.DatosPersonales?.Apellido1 ?? dataUser?.datosPersonales?.apellido1 ?? "",
        apellido2: dataUser?.DatosPersonales?.Apellido2 ?? dataUser?.datosPersonales?.apellido2 ?? "",
        ipf: dataUser?.DatosPersonales?.IPF ?? dataUser?.datosPersonales?.ipf ?? "",
        ipfTipo: dataUser?.DatosPersonales?.IPFTipo ?? dataUser?.datosPersonales?.ipfTipo ?? 1,
        telefono: dataUser?.DatosPersonales?.Telefono ?? dataUser?.datosPersonales?.telefono ?? "",
        fijo: dataUser?.DatosPersonales?.Fijo ?? dataUser?.datosPersonales?.fijo ?? "",
        domicilio: dataUser?.DatosPersonales?.Domicilio ?? dataUser?.datosPersonales?.domicilio ?? "",
        codigoPostal: dataUser?.DatosPersonales?.CodigoPostal ?? dataUser?.datosPersonales?.codigoPostal ?? "",
        provinciaDescripcion: dataUser?.DatosPersonales?.ProvinciaDescripcion ?? dataUser?.DatosPersonales?.Provincia ?? dataUser?.datosPersonales?.provinciaDescripcion ?? "",
        codigoProvincia: dataUser?.DatosPersonales?.CodigoProvincia ?? dataUser?.datosPersonales?.codigoProvincia ?? "",
        codigoLocalidad: dataUser?.DatosPersonales?.CodigoLocalidad ?? dataUser?.datosPersonales?.codigoLocalidad ?? "",
        localidadDescripcion: dataUser?.DatosPersonales?.LocalidadDescripcion ?? dataUser?.datosPersonales?.localidadDescripcion ?? "",
        numeroSeguridadSocial: dataUser?.DatosPersonales?.NumeroSeguridadSocial ?? dataUser?.datosPersonales?.numeroSeguridadSocial ?? ""
      },

      // -----------------------------------
      // MOTIVO CESE
      // -----------------------------------
      MotivoCeseActividad: data?.CeseActividad?.DeclaracionCese ?? true,

      TipoMotivoCeseActividad: data?.CeseActividad?.TipoMotivoCese != null
        ? parseInt(data.CeseActividad.TipoMotivoCese)
        : null,

      FechaMotivoCese: data?.CeseActividad?.FechaMotivoCese || null,

      // -----------------------------------
      // DATOS ECONÓMICOS
      // -----------------------------------
      DatosEconomicosCeseActividad: parseInt(data?.CeseActividad?.TipoMotivoCese) != 0 ? null : data?.CeseActividad?.DatosEconomicos,

      // -----------------------------------
      // CAMPOS ADICIONALES
      // -----------------------------------
      TecnicosProductivosOrganizativos: data?.CeseActividad?.TecnicosProductivosOrganizativos || "",
      EjecucionesCobroDeudas: {
        ImporteTotalIngresos:
          data?.CeseActividad?.EjecucionJudicialIngreso
            ? parseFloat(data.CeseActividad.EjecucionJudicialIngreso)
            : null,
        ImporteTotalEjecuciones:
          data?.CeseActividad?.EjecucionJudicialImporteEjecuciones
            ? parseFloat(data.CeseActividad.EjecucionJudicialImporteEjecuciones)
            : null,
        PorcentajeEjecucionesSobreIngresos:
          data?.CeseActividad?.EjecucionJudicialPorcentaje
            ? parseFloat(data.CeseActividad.EjecucionJudicialPorcentaje)
            : null
      },

      TitularEstablecimiento: data?.CeseActividad?.EstablecimientoMercantil ?? false,
      DomicilioEstablecimiento: data?.CeseActividad?.DomicilioEstablecimiento || ""
    };

    if (info) {
      await createDeclaracionJuradaCeseActividadDirecta(dataUser?.UsuarioId.toString(), datosEnvio, onSuccess)
      setBloquearEnvio(true);
    } else {
      await updateDeclaracionJuradaCeseActividadDirectaById(dataUser?.Id, dataUser?.Id, datosEnvio)
      setBloquearEnvio(true);
    }


    setTimeout(() => {
      setLoader(false); //tiempo cargar DOM
    }, 500);
  };





  return (
    <FormProvider {...formMethods}>
      <div className="container form--simple-styled" id="formDeltawithoutleave">

        {/* ////////////// OBSERVACIONES DEL GESTOR A LA SOLICITUD ////////////// */}
        <FormObservaciones observaciones={datosAPI?.Observaciones} titulo={'Observaciones del Gestor a la Solicitud'} />

        <Loader activeLoader={loader || loadingCreateDeclaracionJuradaCeseActividadDirecta || loadingUpdateDeclaracionJuradaCeseActividadDirectaById} label="Cargando Formulario"></Loader>








        {/* ////////////// COMIENZO FORMULARIO ////////////// */}
        {/* ////////////// DATOS DEL TRABAJADOR ////////////// */}
        <FormInfoCreateUpdate
          isCreate={info}
          estadoFormulario={datosAPI?.EstadoFormulario ?? datosAPI?.estadoFormulario ?? dataUser?.EstadoFormulario ?? dataUser?.estadoFormulario}
          estadoFormularioDescripcion={datosAPI?.EstadoFormularioDescripcion ?? datosAPI?.estadoFormularioDescripcion ?? dataUser?.EstadoFormularioDescripcion ?? dataUser?.estadoFormularioDescripcion}
          fechaActualizacionEstado={datosAPI?.FechaActualizacionEstado ?? datosAPI?.fechaActualizacionEstado ?? dataUser?.FechaActualizacionEstado ?? dataUser?.fechaActualizacionEstado}
        />
        <FieldsetContainer legend="" disabled={false}>
          <p className='mt-2 mb-2 parra-bold'>En virtud de la prescripción recogida en el Título V “protección por cese de actividad” del RD Legislativo 8/2015 de 30 de octubre por el que se
            aprueba el TRLGSS, en cuyo artículo 332 se determina la forma de acreditación de la situación legal de cese de la actividad en cada uno de los
            supuestos tasados que se enumeran en el artículo 331 del mismo cuerpo legal, se certifica lo siguiente</p>
          <p className='mt-2 mb-2 text-left parra-bold'>D./Dña
            <InputTextIntegration
              name="DatosPersonales.SolicitanteNombreCompleto"
              inputType={1}
              disabled={true}
              minWidth={300}
            />

            con número de afiliación a la Seguridad Social
            <InputTextIntegration
              name="DatosPersonales.SolicitanteNumeroSS"
              inputType={1}
              disabled={true}
            />
            con DNI/NIF/pasaporte/NIE número
            <InputTextIntegration
              name="DatosPersonales.SolicitanteIPF"
              inputType={1}
              disabled={true}
            />
            y domicilio en
            <InputTextIntegration
              name="DatosPersonales.SolicitanteDomicilio"
              inputType={1}
              disabled={true}
              minWidth={500}
            />
            declara bajo su responsabilidad que:
          </p>

        </FieldsetContainer>
        <div className='m-3'></div>


        <div className="row mb-4">
          <div className="col-xl-12">


            <FieldsetContainer legend="" disabled={false}>

              <FormInputCheckboxTable
                title="En su condición de trabajador/a autónomo/a declara que ha cesado el ejercicio de su actividad por alguna de estas causas"
                names={["CeseActividad.DeclaracionCese"]}
                required='Debe seleccionar el Motivo del Cese'
                labels={[
                  "Por la concurrencia de motivos económicos, técnicos, productivos u organizativos",
                ]}
                modal={["Por la concurrencia de motivos económicos, técnicos, productivos u organizativos determinantes de la inviabilidad de proseguir la actividad económica o profesional"]}
                col={12}
              />


              <AccordionDisplay dataUser={dataUser} visibility={watch('CeseActividad.DeclaracionCese') === true} fields={['CeseActividad.TipoMotivoCese']}>
                <FormInputRadioGroup
                  title=""
                  name={"CeseActividad.TipoMotivoCese"}
                  labels={[
                    "Pérdidas superiores al 10% de los ingresos",
                    "Motivos técnicos, productivos u organizativos",
                    "Ejecuciones judiciales o administrativas",
                    "Declaración judicial de concurso",
                    "Fallecimiento, jubilación o incapacidad del titular",
                  ]}
                  modal={[
                    "Pérdidas derivadas del ejercicio de su actividad en un año completo superiores al 10% de los ingresos, excluido el primer año de actividad.",
                    "",
                    "Ejecuciones judiciales o administrativas tendentes al cobro de deudas reconocidas por los órganos ejecutivos que comporten, al menos, el 30% de los ingresos del ejercicio económico inmediatamente anterior.",
                    "Declaración judicial de concurso que impida continuar con la actividad, en los términos de la Ley 22/2003, de 9 de julio, Concursal.",
                    "En el caso de autónomo/a que viniera realizando funciones de ayuda familiar por: muerte, jubilación o incapacidad permanente del cónyuge titular del negocio.",
                  ]}
                  col={12}
                />

                <AccordionDisplay dataUser={dataUser} visibility={watch('CeseActividad.TipoMotivoCese') === '0'} fields={['CeseActividad.DatosEconomicos']}>

                  <p className='mt-2 mb-4'>Los datos económicos consignados deben coincidir con la documentación económica fiscal
                    y contable aportada para acreditar la causa del cese</p>


                  <FormInputTable
                    name="CeseActividad.DatosEconomicos"
                    heads={["Ejercicio económico", "Ingresos(A)", "Gastos(B)", "Perdidas (A-B=C)", "% (Perdidas/Ingresos)"]}
                    nameHeads={["EjercicioEconomico", "Ingresos", "Gastos", "Perdidas", "PorcentajePerdidasIngresos"]}
                    validateFunction={validateDatosEconomicos}
                    addButton={false}
                    removeButton={false}
                    inputType={[3, 3, 3, 3, 3]}
                    arrayModal={[null, "", null, "", "Para el Cálculo %: Cx100/A "]}
                    disabledFields={[false, false, false, true, true]}
                  />
                </AccordionDisplay>

                <AccordionDisplay dataUser={dataUser} visibility={watch('CeseActividad.TipoMotivoCese') === '1'} fields={['CeseActividad.TecnicosProductivosOrganizativos']}>
                  <div className="col-xl-12 col-md-12">
                    <TextAreaDefault
                      id='CeseActividad.TecnicosProductivosOrganizativos'
                      name='CeseActividad.TecnicosProductivosOrganizativos'
                      label='Técnicos, productivos u organizativos:'
                      placeholder=""

                    />
                  </div>
                </AccordionDisplay>
                <AccordionDisplay dataUser={dataUser} visibility={watch('CeseActividad.TipoMotivoCese') === '2'} fields={['CeseActividad.EjecucionJudicialIngreso', 'CeseActividad.EjecucionJudicialImporteEjecuciones', 'CeseActividad.EjecucionJudicialPorcentaje']}>
                  <FormInputText
                    name='CeseActividad.EjecucionJudicialIngreso'
                    id='CeseActividad.EjecucionJudicialIngreso'
                    label='Ingresos por la actividad (A):'
                    md={4}
                    xl={4}
                    disabled={false}
                    pattern={/^[0-9]+([.,][0-9]+)?$/}
                    patternMessage="Introduce un número válido (entero o decimal, con '.' o ',')"
                  />
                  <FormInputText
                    name='CeseActividad.EjecucionJudicialImporteEjecuciones'
                    id='CeseActividad.EjecucionJudicialImporteEjecuciones'
                    label='Importe total de las ejecuciones (B):'
                    md={4}
                    xl={4}
                    disabled={false}
                    pattern={/^[0-9]+([.,][0-9]+)?$/}
                    patternMessage="Introduce un número válido (entero o decimal, con '.' o ',')"
                  />
                  <FormInputText
                    name='CeseActividad.EjecucionJudicialPorcentaje'
                    id='CeseActividad.EjecucionJudicialPorcentaje'
                    label='% Ejecuciones/Ingresos:'
                    modal='Cálculo: (Bx100)/A'
                    md={4}
                    xl={4}
                    disabled={true}
                    pattern={/^[0-9]+([.,][0-9]+)?$/}
                    patternMessage="Introduce un número válido (entero o decimal, con '.' o ',')"
                  />
                </AccordionDisplay>
                <div className='m-4'></div>
                <p>
                  Del mismo modo, hace constar que la fecha en la que se ha producido el motivo aducido es:
                  <InputTextIntegration
                    name="CeseActividad.FechaMotivoCese"
                    req='La fecha del motivo de cese es obligatoria'
                    inputType={4}
                    disabled={false}
                    minWidth={150}
                  />
                </p>

                <div className='m-4'></div>

                <FormInputCheckboxTable
                  title="Es titular de un establecimiento mercantil, industrial o de otra naturaleza abierto al público"
                  names={["CeseActividad.EstablecimientoMercantil"]}
                  labels={[
                    "Marquese si procede"
                  ]}
                  col={12}
                />





                <AccordionDisplay dataUser={dataUser} visibility={watch('CeseActividad.EstablecimientoMercantil') === true} fields={['CeseActividad.DomicilioEstablecimiento']}>

                  <p>
                    Es titular de un establecimiento mercantil, industrial o de otra naturaleza abierto al público, situado en (indique
                    dirección completa):
                    <InputTextIntegration
                      name="CeseActividad.DomicilioEstablecimiento"
                      inputType={1}
                      disabled={false}
                      req={watch('CeseActividad.EstablecimientoMercantil') === true ? "El Domicilio del Establecimiento es obligatorio" : null}
                      minWidth={300}
                    />
                    el cual permanecerá cerrado durante todo el período en
                    el que perciba prestación económica por cese de actividad.
                  </p>
                </AccordionDisplay>
              </AccordionDisplay>



            </FieldsetContainer>
          </div>
        </div>

















        {/* ////////////// FINAL FORMULARIO ////////////// */}


        {/* ////////////// BLOQUEO DEL ENVIO DEL FORMULARIO //////////// */}
        <FormBotonSubmit
          disableSubmit={bloquearEnvio}
          onSubmit={handleSubmit(onSubmit)}
          successCreate={successCreateDeclaracionJuradaCeseActividadDirecta}
          successUpdate={successUpdateDeclaracionJuradaCeseActividadDirectaById}
          errorCreate={errorCreateDeclaracionJuradaCeseActividadDirecta}
          errorUpdate={errorUpdateDeclaracionJuradaCeseActividadDirectaById}
          datosAPI={datosAPI}
          info={info}
          BloqueoForm={[1]}
          label='Declara bajo su responsabilidad que son ciertos los datos que se consignan en la presente declaración y que, al día de la fecha, los datos declarados siguen siendo vigentes, informándose que en caso de resultar inciertos, la Mutua se reserva el derecho de reclamación de la prestación a que hubiera dado lugar.'
        />


        <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
          Esta solicitud va a ser tramitada por medios informáticos. Los datos personales que figuran en ella serán incorporados a un fichero de base de datos para el cálculo y control de la prestación económica
          que se le reconozca, y permanecerán bajo custodia de esta Entidad. En cualquier momento puede ejercitar su derecho de acceso, rectificación, cancelación y oposición sobre los datos incorporados al
          fichero ( art. 5 de la ley 15/1999 de 13 diciembre de Protección de datos de carácter personal, BOE del día 14)
        </p>

        <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
          En cumplimiento de lo establecido en la normativa sobre de Protección de Datos de Carácter Personal, Solimat Mutua Colaboradora con la Seguridad Social nº 72 le informa que sus datos de carácter
          personal serán objeto de tratamiento, con la finalidad del mantenimiento y cumplimiento de la relación. La base jurídica que legitima el tratamiento de sus datos es el
          cumplimiento de una obligación legal. Sus datos serán conservados de forma indefinida en nuestra entidad para atender a las posibles responsabilidades derivadas del tratamiento. Usted
          podrá revocar el consentimiento prestado, así como ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, o portabilidad, en su caso, remitiendo un
          escrito a la siguiente dirección: Solimat, Mutua Colaboradora con la Seguridad Social nº 72, C/ Berna, 1, 45003, Toledo, adjuntando su NIF. Si considera que sus derechos no han sido
          debidamente atendidos, puede contactar con nuestro delegado de protección de datos lopd@solimat.com o interponer una reclamación frente a la Agencia Española de Protección de Datos.
        </p>



      </div>
    </FormProvider>
  )
}

export default DeclaracionJuradaCeseActividadDirecta
